import { Directive, HostBinding, Input } from '@angular/core';

/**
 * Directive that applies strikethrough styling to text when the element is archived.
 * This provides a performant way to display archived content without duplicating DOM elements.
 * 
 * Usage:
 * <span [appArchivedText]="fuelreq.archived">{{ fuelreq.paymentMethod }}</span>
 */
@Directive({
    selector: '[appArchivedText]'
})
export class ArchivedTextDirective {
    @Input() appArchivedText: boolean = false;
    
    /**
     * Binds the 'archived-text' CSS class when the element is archived
     */
    @HostBinding('class.archived-text') get archivedClass() {
        return this.appArchivedText;
    }
}

